enum DisputeStatus {
  CREATED = "CREATED",
  WON = "WON",
  LOST = "LOST",
  SUBMITTED = "SUBMITTED",
}

export default DisputeStatus;
